import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { adjustmentReportSortKeySchema } from "./get-adjustment-report";

export const exportAdjustmentReport = {
  name: "exportAdjustmentReport" as const,
  input: z.object({
    search: z.string().optional(),
    sortBy: adjustmentReportSortKeySchema.optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    visibleColumns: z.array(z.object({ key: z.string(), width: z.number() })),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
